<!--
 * @Author: 仙道
 * @Date: 2022-06-21 16:12:52
 * @LastEditTime: 2022-09-18 11:03:43
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/components/pendingOrder.vue
-->
 
<template>
  <grid-table :columns="columns" :queryParams="queryParams" :url="url" ref="table"></grid-table>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GridTable from "../components/table.vue";

  export default {
    name: 'PendingOrder',
    components: {
      GridTable
    },

    // 定义属性
    data () {
      return {
        url: '/workorder/work-order/list',
        queryParams: {
          classify: 1
        },
        columns: [{
          title: '标题',
          align: "center",
          dataIndex: 'title'
        },

        {
          title: '当前状态',
          align: "center",
          dataIndex: 'stateName',
          scopedSlots: { customRender: 'stateName' },
        },
        {
          title: '当前处理人',
          align: "center",
          dataIndex: 'principals',
          scopedSlots: { customRender: 'principals' },
        },
        {
          title: '优先级',
          align: "center",
          dataIndex: 'priority',
          scopedSlots: { customRender: 'priority' },
        },

        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: "center"
        }]
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      queryData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>